export class BaseFlag {
  constructor(node) {
    this.node = node;
    this._state = true;
    this._hooks = null;
  }
  onUpdate(hook) {
    this._hooks = this._hooks || [];
    this._hooks.push(hook);
  }
  _on_update() {
  }
  set(new_state) {
    if (this._state != new_state) {
      this._state = new_state;
      this._on_update();
      this.runHooks();
    }
  }
  active() {
    return this._state;
  }
  toggle() {
    this.set(!this._state);
  }
  runHooks() {
    if (this._hooks) {
      for (let hook of this._hooks) {
        hook();
      }
    }
  }
}
